import { createContext, useCallback, useContext, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { OrderModal } from "@/components/site/OrderModal";

const Ctx = createContext({ open: () => {} });

export const OrderProvider = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const open = useCallback(() => setOpen(true), []);
  return (
    <Ctx.Provider value={{ open }}>
      {children}
      <OrderModal open={isOpen} onOpenChange={setOpen} />
    </Ctx.Provider>
  );
};

export const useOrder = () => useContext(Ctx);

export const OrderButton = ({ className = "btn btn-berry", children = "Order online", testId = "order-online-btn" }) => {
  const { open } = useOrder();
  return (
    <button type="button" onClick={open} className={className} data-testid={testId}>
      {children}
      <ArrowUpRight className="h-4 w-4" aria-hidden />
    </button>
  );
};
